import type { AccountRecord } from "../organization/organization.types";
import type { LessonConsumption } from "../scheduling/scheduling.types";
import type { CoursePackage } from "./sales.types";

export function scopedCoursePackages(
  role: "employee" | "manager",
  actorId: string,
  storeId: string | null,
  accounts: AccountRecord[],
  packages: CoursePackage[],
) {
  const storeMemberIds = new Set(
    accounts
      .filter((account) => account.role === "member" && account.storeId === storeId)
      .map((account) => account.id),
  );
  const serviceMemberIds = new Set(
    accounts
      .filter(
        (account) =>
          account.role === "member" &&
          (account.coachId === actorId || account.serviceCoachIds?.includes(actorId)),
      )
      .map((account) => account.id),
  );
  return packages.filter((item) =>
    role === "employee"
      ? serviceMemberIds.has(item.memberId)
      : storeMemberIds.has(item.memberId),
  );
}

export function courseUnitBreakdown(
  coursePackage: CoursePackage,
  consumptions: LessonConsumption[],
) {
  const activeSystemUsed = consumptions
    .filter(
      (item) =>
        item.packageId === coursePackage.id && item.status === "active",
    )
    .reduce((sum, item) => sum + item.units, 0);
  const openingUsed = Math.max(
    0,
    Number(coursePackage.openingUsedUnits ?? coursePackage.usedUnits - activeSystemUsed),
  );
  return {
    purchased: Number(coursePackage.purchasedUnits ?? coursePackage.totalUnits),
    gifted: Number(coursePackage.giftUnits ?? 0),
    used: coursePackage.usedUnits,
    openingUsed,
    activeSystemUsed,
    remaining: Math.max(0, coursePackage.totalUnits - coursePackage.usedUnits),
  };
}
